import { createSlice } from "@reduxjs/toolkit";
import moment from "moment";

function getDefaultRange() {
  return {
    start: moment().subtract(6, "days").startOf("day").toISOString(),
    end: moment().endOf("day").toISOString(),
  };
}

const dashboardDateRangeSlice = createSlice({
  name: "dashboardDateRange",
  initialState: getDefaultRange(),
  reducers: {
    setDashboardDateRange(state, action) {
      const { start, end } = action.payload || {};
      if (!start) return;
      state.start = start;
      state.end = end || start;
    },
  },
});

export const { setDashboardDateRange } = dashboardDateRangeSlice.actions;
export default dashboardDateRangeSlice.reducer;
